import React from 'react'

//
import { ConditionalWrapper } from '../helpers'
import Image from 'next/image'
import Link from 'next/link'
import IconNew from '../IconNew'

const Search = ({ url, label, logo }) => {
  const getAbsoluteUrl = (src) => {
    if (!src) return null
    if (src.startsWith('http://') || src.startsWith('https://')) {
      return src
    }
    return `https:${src}` // Assuming HTTPS is preferred
  }

  const logoUrl =
    typeof logo === 'object'
      ? getAbsoluteUrl(logo?.url)
      : typeof logo === 'string'
      ? getAbsoluteUrl(logo)
      : null

  return (
    <ConditionalWrapper
      condition={url}
      trueWrapper={(child) => (
        <Link href={url} className="c-search-result">
          {child}
        </Link>
      )}
      falseWrapper={(child) => <div className="c-search-result">{child}</div>}
    >
      {logoUrl && (
        <Image
          className="c-search-result__logo"
          loading="lazy"
          src={logoUrl}
          alt={label}
          title={label}
          width="32"
          height="32"
        />
      )}

      {label}
      {url && <IconNew classes="c-integration__url-icon" name="tabler-external-link" size={16} />}
    </ConditionalWrapper>
  )
}

export default Search
